
/* START_TEMPLATE */
define('hbs!app/templates/inline_error',['hbs','Handlebars'], function( hbs, Handlebars ){ 
var t = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;
  return "<small class=\""
    + escapeExpression(((helper = (helper = helpers.behavior_classes || (depth0 != null ? depth0.behavior_classes : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"behavior_classes","hash":{}}) : helper)))
    + "\">"
    + escapeExpression(((helper = (helper = helpers.error_text || (depth0 != null ? depth0.error_text : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"error_text","hash":{}}) : helper)))
    + "</small>\n";
}});
Handlebars.registerPartial('app/templates/inline_error', t);
return t;
});
/* END_TEMPLATE */
;
